import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";
import { useEffect, useState } from "react";
import { delJobById, getJobs } from "../../api";
import toast from "react-hot-toast";
import Modal from "../../components/modal/modal";

const Jobs = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [del_id, setDelId] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getJobs()
      .then((res) => {
        console.log("jobs data ::: ", res.data);
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setLoading(false);
      });
  };

  const handleDelete = () => {
    setModal(false);
    setLoading(true);

    delJobById(del_id)
      .then(() => {
        toast.success("Deleted Successfully.");
        getData();
        setDelId("");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setLoading(false);
        setDelId("");
      });
  };

  return (
    <>
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setDelId("");
          setModal(false);
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <WithTableView
        heading="Jobs"
        head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
        body_keys={["jobTitle", "action:delete"]}
        body={data}
        show_btn_1={true}
        isIcon={true}
        iconType="add"
        btn1Text={"Job"}
        btn1Type={"filled"}
        onClickHandler={() => {
          navigate("/jobs/add");
        }}
        onRowClick={(e) => {
          navigate("/jobs/" + e._id);
        }}
        onActionClick={(_, e) => {
          setDelId(e);
          setModal(true);
        }}
        loading={loading}
        customElement={<></>}
      />
    </>
  );
};

export default Jobs;
